import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { ButtonFilterStyle } from "components/Atomos/ButtonFilterStyle";
import { ptBR } from "date-fns/locale";
import React, { forwardRef } from "react";
import DatePickerDefault, {
    ReactDatePickerProps,
    registerLocale
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RiCalendar2Line } from "react-icons/ri";
import { Container } from "./styles";
registerLocale("pt-BR", ptBR);

interface Props extends ReactDatePickerProps<"DatePicker", true> {
    label?: string;
}

export const DatePicker: React.FC<Props> = ({ label, ...rest }) => {
    const lightMode = useColorModeValue("light", "");
    return (
        <Container light={lightMode}>
            <DatePickerDefault
                {...rest}
                locale="pt-BR"
                dateFormat="dd/MM/yyyy"
                customInput={<CustomInput label={label} />}
            />
        </Container>
    );
};

interface CustomInputProps {
    label?: string;
    value?: string;
    onClick?: () => void;
}

const CustomInput = forwardRef(function CustomInput(
    { label, value, onClick }: CustomInputProps,
    ref: React.Ref<HTMLButtonElement>
) {
    return (
        <ButtonFilterStyle onClick={onClick || console.log} ref={ref}>
            <Flex alignItems="center" px="5">
                <Text as="span" color="blue.400">
                    <RiCalendar2Line />
                </Text>
                <Text as="span" px="2" fontWeight="normal" minW="140px">
                    {value || label}
                </Text>
            </Flex>
        </ButtonFilterStyle>
    );
});